import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../../Assets/CSS/Styles.scss";
import { API_BASE_URL } from '../../config';

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL}/api/blogs/${id}`)
      .then((res) => {
        setBlog(res.data);
      })
      .catch((err) => {
        console.error("Error fetching blog:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!blog) return <p className="text-center py-10">No blog available.</p>;

  return (
   <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8 md:py-12 max-w-4xl mt-8 sm:mt-12 md:mt-16 mt60">
      {/* Card Container */}
      <div className="bg-white rounded-lg md:rounded-xl shadow-lg md:shadow-2xl overflow-hidden transition-all duration-300 hover:shadow-xl md:hover:shadow-3xl">
        {/* Blog Image with responsive height */}
        {blog.image && (
          <div className="relative">
            <img
              src={`${API_BASE_URL}/uploads/${blog.image}`}
              alt={blog.title}
              className="w-full h-48 sm:h-64 md:h-80 lg:h-96 object-cover shadow-sm md:shadow-md"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
          </div>
        )}

        {/* Card Body with responsive padding */}
        <div className="p-4 sm:p-6 md:p-8">
          {/* Responsive title sizing */}
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2 sm:mb-3 text-gray-800 [text-shadow:_0_1px_1px_rgb(0_0_0_/_0.1)] md:[text-shadow:_0_1px_2px_rgb(0_0_0_/_0.1)]">
            {blog.title}
          </h1>

          {/* Responsive author/date layout */}
          <div className="flex flex-wrap items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
            <span className="text-xs sm:text-sm text-gray-500 px-2 sm:px-3 py-1 bg-gray-100 rounded-full">
              By {blog.author || "Unknown"}
            </span>
            <span className="text-gray-400 hidden sm:block">•</span>
            <span className="text-xs sm:text-sm text-gray-500 px-2 sm:px-3 py-1 bg-gray-100 rounded-full">
              {blog.publishDate
                ? new Date(blog.publishDate).toLocaleDateString()
                : "No date"}
            </span>
          </div>

          {/* Blog Sections with responsive spacing */}
          {blog.sections && blog.sections.length > 0 && (
            <div className="space-y-3 sm:space-y-4">
              {blog.sections.map((section, index) => (
                <div
                  key={index}
                  className="py-2 sm:py-3 transition-all duration-200"
                >
                  {section.title && (
                    <h2 className="text-lg sm:text-xl font-semibold mb-1 sm:mb-2 text-gray-800">
                      {section.title}
                    </h2>
                  )}

                  {section.description && (
                    <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-2">
                      {section.description}
                    </p>
                  )}

                  {section.points && section.points.length > 0 && (
                    <ul className="list-disc ml-4 sm:ml-5 space-y-1 text-sm sm:text-base text-gray-700">
                      {section.points.map((point, i) => (
                        <li key={i}>{point}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}

          
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
